(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["soma-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('soma-carousel')) {
    class SomaCarousel extends HTMLElement {
      constructor() {
        super();
        this.onPrev = () => this.go(-1);
        this.onNext = () => this.go(1);
        this.onKeydown = this.onKeydown.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onSlideClick = this.onSlideClick.bind(this);
        this.update = this.update.bind(this);
        this.tween = this.tween.bind(this);
        this.init = this.init.bind(this);
      }

      connectedCallback() {
        this.viewport = this.querySelector('.sc__viewport');
        if (!this.viewport) return;

        if (window.EmblaCarousel) {
          this.init();
        } else if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.init, { once: true });
        } else {
          window.addEventListener('load', this.init, { once: true });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.init);
        window.removeEventListener('load', this.init);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (!this.embla) return;

        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
        this.viewport.removeEventListener('keydown', this.onKeydown);
        this.viewport.removeEventListener('click', this.onSlideClick, true);
        this.clearFocus();
        this.embla.destroy();
        this.embla = null;
        this.classList.remove('sc--ready');
      }

      init() {
        if (this.embla || !this.isConnected || !window.EmblaCarousel) return;

        this.slides = Array.from(this.viewport.querySelectorAll(':scope > .sc__track > .sc-slide'));
        if (this.slides.length === 0) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.loop = this.hasAttribute('data-loop');
        this.featured = this.hasAttribute('data-featured');
        this.featuredQuery = window.matchMedia('(min-width: 750px)');
        this.arrows = this.querySelector('.sc__arrows');
        this.prev = this.querySelector('.sc__arrow--prev');
        this.next = this.querySelector('.sc__arrow--next');

        this.slides.forEach((slide, index) => {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute('aria-label', `${index + 1} of ${this.slides.length}`);
          slide.querySelectorAll('img').forEach((img) => (img.draggable = false));
        });

        this.viewport.scrollLeft = 0;
        this.classList.add('sc--ready');
        this.embla = window.EmblaCarousel(this.viewport, {
          align: 'start',
          containScroll: 'trimSnaps',
          loop: this.loop,
          slidesToScroll: 1,
          duration: 25,
          breakpoints: this.featured ? { '(min-width: 750px)': { align: 'center', containScroll: false } } : {},
        });

        this.embla.on('select', this.update).on('reInit', this.update);
        if (this.featured) {
          this.embla.on('scroll', this.tween).on('select', this.tween).on('settle', this.tween).on('reInit', this.tween);
          this.viewport.addEventListener('click', this.onSlideClick, true);
        }
        this.prev?.addEventListener('click', this.onPrev);
        this.next?.addEventListener('click', this.onNext);
        this.viewport.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.update();
        if (this.featured) this.tween();
      }

      clearFocus() {
        this.slides.forEach((slide) => {
          slide.classList.remove('sc-slide--active');
          slide.style.removeProperty('--sc-focus');
        });
      }

      tween() {
        if (!this.embla) return;
        if (!this.featuredQuery.matches) {
          this.clearFocus();
          return;
        }

        const engine = this.embla.internalEngine();
        const progress = this.embla.scrollProgress();
        const snaps = this.embla.scrollSnapList();
        const selected = this.embla.selectedScrollSnap();

        snaps.forEach((snap, snapIndex) => {
          engine.slideRegistry[snapIndex].forEach((slideIndex) => {
            let distance = snap - progress;

            engine.slideLooper.loopPoints.forEach((point) => {
              const target = point.target();
              if (point.index !== slideIndex || target === 0) return;
              distance = target < 0 ? snap - (1 + progress) : snap + (1 - progress);
            });

            const focus = Math.min(Math.max(1 - Math.abs(distance * snaps.length), 0), 1);
            const slide = this.slides[slideIndex];
            slide.style.setProperty('--sc-focus', focus.toFixed(3));
            slide.classList.toggle('sc-slide--active', snapIndex === selected);
          });
        });
      }

      onSlideClick(event) {
        if (event.defaultPrevented || !this.featuredQuery.matches) return;

        const slide = event.target.closest('.sc-slide');
        const index = this.slides.indexOf(slide);
        if (index < 0 || slide.classList.contains('sc-slide--active')) return;

        event.preventDefault();
        event.stopPropagation();
        this.embla.scrollTo(index, this.reducedMotion.matches);
      }

      go(direction) {
        if (!this.embla) return;

        if (this.reducedMotion.matches) {
          const count = this.embla.scrollSnapList().length;
          const target = this.embla.selectedScrollSnap() + direction;
          this.embla.scrollTo(this.loop ? (target + count) % count : target, true);
        } else if (direction < 0) {
          this.embla.scrollPrev();
        } else {
          this.embla.scrollNext();
        }
      }

      update() {
        if (!this.embla || !this.arrows) return;

        this.arrows.hidden = this.embla.scrollSnapList().length <= 1;
        this.prev.disabled = !this.embla.canScrollPrev();
        this.next.disabled = !this.embla.canScrollNext();
      }

      onKeydown(event) {
        if (event.target !== this.viewport) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(1);
        }
      }

      onBlockSelect(event) {
        if (!this.embla || !this.contains(event.target)) return;

        const slide = event.target.closest('.sc-slide');
        const index = this.slides.indexOf(slide);
        if (index < 0) return;

        const lastSnap = this.embla.scrollSnapList().length - 1;
        this.embla.scrollTo(Math.min(index, lastSnap), this.reducedMotion.matches);
      }
    }

    customElements.define('soma-carousel', SomaCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
